import { render, staticRenderFns } from "./ReadOnlyFields.vue?vue&type=template&id=fa21e064&scoped=true&"
import script from "./ReadOnlyFields.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyFields.vue?vue&type=script&lang=js&"
import style0 from "./ReadOnlyFields.vue?vue&type=style&index=0&id=fa21e064&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa21e064",
  null
  
)

export default component.exports